import React from 'react';
// React-table library requires to import css as well:
import ReactTable from 'react-table';
import 'react-table/react-table.css'; // eslint-disable-next-line
import { Button, Container, IconButton, Typography } from '@material-ui/core';
import { withStyles, withTheme } from '@material-ui/styles';
import { DeleteForever } from '@material-ui/icons';
import PropTypes from 'prop-types';
import { getConsulenteId } from '../../../utils/storage';
import moment from 'moment';
import 'moment/locale/it';
import ModalGiorniChiusura from './ModalGiorniChiusura';

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    gap: theme.spacing(5),
    width: '100%',
    padding: '0px 0px 20px 0px',
  },
  title: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(2),
    marginBottom: theme.spacing(1),
  },
});

class GiorniChiusuraEsercizio extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      modalApertura: false,
    };
  }

  deleteElement = (cellInfo) => {
    let array1 = this.props.giorniChiusura.filter((a) => a.apertura === false);
    array1.splice(cellInfo.index, 1);
    // alert(JSON.stringify(        array1.splice(cellInfo.index, 1)))
    let array = this.props.giorniChiusura.filter((a) => a.apertura === true);

    let concat = array1.concat(array);

    this.props.updateGiorniChiusura(concat);
  };

  deleteElementEventi = (cellInfo) => {
    let array = this.props.giorniChiusura.filter((a) => a.apertura === true);

    let array1 = this.props.giorniChiusura.filter((a) => a.apertura === false);
    array.splice(cellInfo.index, 1);
    let concat = array.concat(array1);
    this.props.updateGiorniChiusura(concat);
  };

  completeModal = () => {
    this.setState({
      modal: false,
    });
  };

  openModal = () => {
    this.setState({
      modal: true,
    });
  };

  closeModal = () => {
    this.setState({
      modal: false,
    });
  };

  completeModalApertura = () => {
    this.setState({
      modalApertura: false,
    });
  };

  openModalApertura = () => {
    this.setState({
      modalApertura: true,
    });
  };

  closeModalApertura = () => {
    this.setState({
      modalApertura: false,
    });
  };

  render() {
    const { classes, theme } = this.props;

    let isUserConsulente =
      getConsulenteId() !== null && getConsulenteId() !== 'null';
    const dateFormat = 'DD-MM-YYYY';

    const columns = [
      {
        Header: 'Tipo',
        id: 'tipo',
        accessor: (d) => {
          switch (d.tipo) {
            case 'RICORRENTE':
              return 'Ricorrente';
            case 'PERIODO':
              return 'Periodo';
            case 'SPECIFICO':
              return 'Giorno specifico';

            default:
              return '-';
          }
        },
        sortable: false,
        filterable: false,
        minWidth: 120,
      },
      {
        Header: 'Data inizio',
        id: 'dataInizio',
        sortable: false,
        filterable: false,
        accessor: (d) =>
          d.dataInizio ? moment(d.dataInizio).format(dateFormat) : '-',
        minWidth: 120,
      },
      {
        Header: 'Data fine',
        id: 'dataFine',
        sortable: false,
        filterable: false,
        accessor: (d) =>
          d.dataFine ? moment(d.dataFine).format(dateFormat) : '-',
        minWidth: 120,
      },
      {
        Header: 'Data Specifica',
        id: 'dataSpecifica',
        sortable: false,
        filterable: false,
        accessor: (d) =>
          d.dataSpecifica ? moment(d.dataSpecifica).format(dateFormat) : '-',
        minWidth: 120,
      },
      {
        Header: 'Orario Inizio',
        id: 'orarioInizio',
        sortable: false,
        filterable: false,
        accessor: (d) => (d.orarioInizio ? d.orarioInizio : '-'),
        minWidth: 120,
      },
      {
        Header: 'Orario Fine',
        id: 'orarioFine',
        sortable: false,
        filterable: false,
        accessor: (d) => (d.orarioFine ? d.orarioFine : '-'),
        minWidth: 120,
      },
      {
        Header: 'Giorno',
        id: 'giorno',
        sortable: false,
        filterable: false,
        accessor: (d) => {
          switch (d.giorno) {
            case 'MONDAY':
              return 'Lunedì';
            case 'TUESDAY':
              return 'Martedì';
            case 'WEDNESDAY':
              return 'Mercoledì';
            case 'THURSDAY':
              return 'Giovedì';
            case 'FRIDAY':
              return 'Venerdì';
            case 'SATURDAY':
              return 'Sabato';
            case 'SUNDAY':
              return 'Domenica';

            default:
              return '-';
          }
        },
        width: 120,
      },
      {
        Header: 'Intervallo',
        id: 'intervallo mensile',
        sortable: false,
        filterable: false,
        accessor: (d) => {
          switch (d.ripetizioneSettimanale) {
            case 1:
              return 'Prima settimana';
            case 2:
              return 'Seconda settimana';
            case 3:
              return 'Terza settimana';
            case 4:
              return 'Quarta settimana';
            case 5:
              return 'Ultima settimana';

            default:
              return '-';
          }
        },
        minWidth: 120,
      },
      {
        Header: 'Elimina',
        id: 'elimina',
        sortable: false,
        filterable: false,
        minWidth: 120,
        accessor: (row) => row,

        Cell: (props) => (
          <IconButton
            disabled={this.props.disabledButtons}
            onClick={() => this.deleteElement(props)}
            style={{
              color: this.props.disabledButtons
                ? theme.palette.disabled.main
                : theme.palette.primary.main,
            }}
          >
            <DeleteForever />
          </IconButton>
        ),
      },
    ];

    const columnsApertura = [
      {
        Header: 'Tipo',
        id: 'tipo',
        accessor: (d) => {
          switch (d.tipo) {
            case 'RICORRENTE':
              return 'Ricorrente';
            case 'PERIODO':
              return 'Periodo';
            case 'SPECIFICO':
              return 'Giorno specifico';

            default:
              return '-';
          }
        },
        sortable: false,
        filterable: false,
        minWidth: 150,
      },
      {
        Header: 'Data inizio',
        id: 'dataInizio',
        sortable: false,
        filterable: false,
        accessor: (d) =>
          d.dataInizio ? moment(d.dataInizio).format(dateFormat) : '-',
        minWidth: 120,
      },
      {
        Header: 'Data fine',
        id: 'dataFine',
        sortable: false,
        filterable: false,
        accessor: (d) =>
          d.dataFine ? moment(d.dataFine).format(dateFormat) : '-',
        minWidth: 120,
      },
      {
        Header: 'Data Specifica',
        id: 'dataSpecifica',
        sortable: false,
        filterable: false,
        accessor: (d) =>
          d.dataSpecifica ? moment(d.dataSpecifica).format(dateFormat) : '-',
        minWidth: 120,
      },
      {
        Header: 'Orario Inizio',
        id: 'orarioInizio',
        sortable: false,
        filterable: false,
        accessor: (d) => (d.orarioInizio ? d.orarioInizio : '-'),
        minWidth: 120,
      },
      {
        Header: 'Orario Fine',
        id: 'orarioFine',
        sortable: false,
        filterable: false,
        accessor: (d) => (d.orarioFine ? d.orarioFine : '-'),
        minWidth: 120,
      },
      {
        Header: 'Giorno',
        id: 'giorno',
        sortable: false,
        filterable: false,
        accessor: (d) => {
          switch (d.giorno) {
            case 'MONDAY':
              return 'Lunedì';
            case 'TUESDAY':
              return 'Martedì';
            case 'WEDNESDAY':
              return 'Mercoledì';
            case 'THURSDAY':
              return 'Giovedì';
            case 'FRIDAY':
              return 'Venerdì';
            case 'SATURDAY':
              return 'Sabato';
            case 'SUNDAY':
              return 'Domenica';

            default:
              return '-';
          }
        },
        width: 120,
      },
      {
        Header: 'Intervallo',
        id: 'intervallo mensile',
        sortable: false,
        filterable: false,
        accessor: (d) => {
          switch (d.ripetizioneSettimanale) {
            case 1:
              return 'Prima settimana';
            case 2:
              return 'Seconda settimana';
            case 3:
              return 'Terza settimana';
            case 4:
              return 'Quarta settimana';
            case 5:
              return 'Ultima settimana';

            default:
              return '-';
          }
        },
        minWidth: 120,
      },
      {
        Header: 'Elimina',
        id: 'elimina',
        sortable: false,
        filterable: false,
        minWidth: 120,
        accessor: (row) => row,

        Cell: (props) => (
          <IconButton
            onClick={() => this.deleteElementEventi(props)}
            disabled={this.props.disabledButtons}
            style={{
              color: this.props.disabledButtons
                ? theme.palette.disabled.main
                : theme.palette.primary.main,
            }}
          >
            <DeleteForever />
          </IconButton>
        ),
      },
    ];

    return (
      <Container className={classes.container}>
        <ModalGiorniChiusura
          esercizioId={this.props.esercizioId}
          handleComplete={this.completeModal}
          handleClose={this.closeModal}
          giorniChiusura={this.props.giorniChiusura}
          modal={this.state.modal}
          isConsulente={isUserConsulente}
          updateGiorniChiusura={this.props.updateGiorniChiusura}
          apertura={false}
        />
        <ModalGiorniChiusura
          esercizioId={this.props.esercizioId}
          handleComplete={this.completeModalApertura}
          handleClose={this.closeModalApertura}
          giorniChiusura={this.props.giorniChiusura}
          modal={this.state.modalApertura}
          isConsulente={isUserConsulente}
          updateGiorniChiusura={this.props.updateGiorniChiusura}
          apertura={true}
        />
        <div>
          <div className={classes.title}>
            <Typography variant="h5">Gestione giorni chiusura</Typography>
            <Button
              type="button"
              disabled={this.props.disabledButtons}
              onClick={() => this.openModal()}
              variant="contained"
              style={{
                color: this.props.disabledButtons
                  ? theme.palette.text.disabled
                  : theme.palette.text.main,
                backgroundColor: this.props.disabledButtons
                  ? theme.palette.disabled.main
                  : theme.palette.primary.main,
              }}
            >
              Aggiungi giorno chiusura
            </Button>
          </div>
          <ReactTable
            filterable={true}
            resizable={true}
            showPageSizeOptions={true}
            showPageJump={true}
            defaultPageSize={10}
            //pages={this.state.pages}
            data={this.props.giorniChiusura.filter((a) => a.apertura === false)}
            columns={columns}
            //manual // informs React Table that you'll be handling sorting and pagination server-side
            //onFetchData={ (state, instance) => { this.fetchData(state.page, state.pageSize) } }
            previousText="Precedente"
            nextText="Successivo"
            noDataText="Nessun record"
            pageText="Pagina"
            ofText="di"
            rowsText="righe"
            pageJumpText="Vai a pagina"
            rowsSelectorText="righe per pagina"
          />
        </div>
        <div>
          <div className={classes.title}>
            <Typography variant="h5">
              Gestione giorni apertura straordinaria
            </Typography>
            <Button
              type="button"
              disabled={this.props.disabledButtons}
              onClick={() => this.openModalApertura()}
              variant="contained"
              style={{
                color: this.props.disabledButtons
                  ? theme.palette.text.disabled
                  : theme.palette.text.main,
                backgroundColor: this.props.disabledButtons
                  ? theme.palette.disabled.main
                  : theme.palette.primary.main,
              }}
            >
              Aggiungi apertura straordinaria
            </Button>
          </div>
          <ReactTable
            filterable={true}
            resizable={true}
            showPageSizeOptions={true}
            showPageJump={true}
            defaultPageSize={10}
            //pages={this.state.pages}
            data={this.props.giorniChiusura.filter((a) => a.apertura === true)}
            columns={columnsApertura}
            //manual // informs React Table that you'll be handling sorting and pagination server-side
            //onFetchData={ (state, instance) => { this.fetchData(state.page, state.pageSize) } }
            previousText="Precedente"
            nextText="Successivo"
            noDataText="Nessun record"
            pageText="Pagina"
            ofText="di"
            rowsText="righe"
            pageJumpText="Vai a pagina"
            rowsSelectorText="righe per pagina"
          />
        </div>
      </Container>
    );
  }
}

GiorniChiusuraEsercizio.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  giorniChiusura: PropTypes.array.isRequired,
  updateGiorniChiusura: PropTypes.func.isRequired,
  esercizioId: PropTypes.number,
  disabledButtons: PropTypes.bool,
};

export default withTheme(
  withStyles(styles, { withTheme: true })(GiorniChiusuraEsercizio),
);
